import React from 'react';
import { Download, X } from 'lucide-react';
import T from 'Components/Helpers/translate';
import { downloadFile } from './downloadFile';

type Props = {
	src: string;
	onClose: () => void;
};

const filenameFromUrl = (src: string): string => {
	try {
		const url = new URL(src, window.location.href);
		const last = url.pathname.split('/').pop();
		return last && last.includes('.') ? last : 'image.png';
	} catch {
		return 'image.png';
	}
};

const ImageModal = ({ src, onClose }: Props) => (
	<div
		className="fixed inset-0 z-[10020] bg-foreground/75 backdrop-blur-sm flex items-center justify-center cursor-pointer"
		onClick={onClose}
	>
		<div className="relative max-w-[90vw] max-h-[90vh]" onClick={e => e.stopPropagation()}>
			<div className="absolute -top-3 -right-3 flex gap-2">
				<button
					onClick={() => downloadFile(src, filenameFromUrl(src))}
					type="button"
					aria-label={T('default.download')}
					title={T('default.download')}
					className="h-8 w-8 rounded-full bg-background text-foreground flex items-center justify-center cursor-pointer hover:bg-secondary shadow-sm"
				>
					<Download className="h-4 w-4" />
				</button>
				<button
					onClick={onClose}
					type="button"
					aria-label={T('assistant.close')}
					title={T('assistant.close')}
					className="h-8 w-8 rounded-full bg-background text-foreground flex items-center justify-center cursor-pointer hover:bg-secondary shadow-sm"
				>
					<X className="h-4 w-4" />
				</button>
			</div>
			<img src={src} alt="" className="max-w-[90vw] max-h-[90vh] object-contain rounded" />
		</div>
	</div>
);

export default ImageModal;
